
import React, { FunctionComponent } from "react";

import { UpdatePageModel } from "../UpdatePageModel";
import { TargetCounts } from "components";
import { ManufacturersService, UpdateTypesService } from "services";
import { pluralize } from "services/Utils";

interface UpdateInfoCardProps {
    model: UpdatePageModel,
    onClick: () => void,
}

export const UpdateInfoCard: FunctionComponent<UpdateInfoCardProps> = function UpdateInfoCard(props) {
    const { model, onClick } = props;
    const { update } = model;

    // TODO - We should copy the update props here to prevent any background changes from being applied to us.

    // Apply a maxlength to the card description
    let description = update.notes || '';
    const notesMaxLen = 200;
    if (description.length > notesMaxLen) {
        description = description.substring(0, notesMaxLen).trim() + '...';
    }

    const manufacturer = ManufacturersService.manufacturersMap[update.manufacturerId];
    const updateType = UpdateTypesService.updateTypesMap[update.updateTypeId];

    return (<div className="update_card clickable" onClick={onClick}>
        <div className="update_card_title ellipsis">
            {update.name}
        </div>
        <div className="update_card_updateFileInfo">
            <div className="ellipsis">
                {!!update.manufacturerId && (<>
                    {manufacturer ? manufacturer.name : ('Unknown manufacturer: ' + update.manufacturerId)}
                </>)}
                {!update.manufacturerId && 'No manufacturer'}
            </div>
            <div className="ellipsis">
                {!!update.updateTypeId && (<>
                    {updateType ? updateType.description : ('Unknown updateType: ' + update.updateTypeId)}
                </>)}
                {!update.updateTypeId && 'No update type'}
            </div>
            <div className="ellipsis">
                {update.updateFileVersion || 'No version'} - {update.updateFileDescription || 'No description'}
            </div>
        </div>
        <div className="update_card_models">
            <b>{update.deviceModelIds.length || 0}</b>&nbsp;
            {pluralize(update.deviceModelIds?.length, 'selected model', 'selected models')}:
            <ul className="update_card_modelsList">
                {update.deviceModelIds.map((modelId) => (
                    <li key={modelId}>
                        {ManufacturersService.modelsMap[modelId]?.name || ('Unknown model: ' + modelId)}
                    </li>
                ))}
            </ul>
        </div>
        {description && (
            <div className="update_card_description">
                {description}
            </div>
        )}
        <div className="update_card_targets">
            <div>Global filters target:</div>
            <div>
                <TargetCounts
                    status={model.affectedStatus}
                    numDevices={model.affected?.rollout.global.result.devicesCount}
                    numLocations={model.affected?.rollout.global.result.locationsCount}
                />
            </div>
        </div>
    </div>);
}